export default __webpack_public_path__ + "static/media/spinner.fce7ae32.gif";